import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { first } from 'rxjs/operators';
import { FormControl, FormGroup,FormArray, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { MailCenterService } from 'src/app/mail-center/mail-center.service';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';
@Component({
  selector: 'app-other-jobs',
  templateUrl: './other-jobs.component.html',
  styleUrls: ['./other-jobs.component.css']
})
export class OtherJobsComponent implements OnInit {
  inventionDetailData:any;

users:any;
users1:any;
  token:any;
  loggedUser="";
  //Job
newJob=false;
viewUpdateJob=false;
  error:any;
  searchText:any;
  record="";
  recordTitle="";
  recordType="";
  recordDetail="";
  recordDocument="";
  recordAttorney="";
  recordTermination="";
// UpdateJob
jobNumber=0;
//Folder Loading
  path="";
  isFolderLoaded=false;
  randomNumber=1;
  firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/patent-book.appspot.com/o/";
  firebaseStorageLink2:string="?alt=media&token=4f6bc9ca-ff7a-408b-800b-a85f5a82eb97";
  docLink:any=[];

  constructor(private userData:UserDataService, private auth:AuthService, private af:AngularFireStorage, private route:Router,private mailService:MailCenterService){}


    ngOnInit() {

      this.randomNumber=Math.floor((Math.random() * 100000) + 1);
     this.token=this.auth.token;
     this.loggedUser=this.auth.userMail;
     this.userData.fetchJobs(this.token).subscribe(
      (res: any) => {

       if (!res) {
         this.record="İş Bulunamadı";
         alert("İş Bulunamadı")
       } else {

       //console.log(res);

       this.users = Object.keys(res).map((key) =>
       {   return res[key][0]
        });
        this.users1 = Object.keys(res).map((key) =>
        { return res[key] });
        this.users1.key = Object.keys(res).map((key) =>
      { return (key) });
        this.docLink=this.users;
          console.log(this.users,res);

        console.log(this.docLink)
          this.record=""
        }},err=>this.error=(err.statusText)
      );

       }





       findJobs() {}
       toggle() {this.newJob = !this.newJob}
       jobDone(i:number){
        if(confirm(this.users1[i][0].recordTitle+" dosya güncellencektir. Onaylıyor musunuz?")){
          console.log(this.users1[i][0].status[0]);
          const reminderTime = (Math.floor (new Date(this.users1[i][0].terminationDate).getTime())/ 1000)
          // console.log(this.users[i][0]);
          /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Başvuru Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
          this.userData.deletionRecords([this.loggedUser,Date.now()],'İş Durumu Güncellendi', `Güncellenen Dosya: ${this.users1[i][0].recordTitle} `).subscribe();
          // console.log(this.loggedUser);
           /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
           console.log(this.users);
           if (this.users1[i][0].status[0].includes("Tamamlandı")) {this.users1[i][0].status[0]="Devam Ediyor";
           const date = new Date(this.users1[i][0].terminationDate);
           const unixTimestamp = Math.floor(date.getTime() / 1000);
           const reminder= [unixTimestamp, reminderTime-172800,reminderTime-432000,]  // Termin tarihinden 2 gün ve 5 gün önce

           this.mailService.jobReminder(this.users1[i][0].terminationDate,this.users1[i][0].recordTitle, reminder).pipe(first())
           .subscribe((resp: any) => {
           console.log({ resp });

           alert("Termin tarihinden 2 gün ve 5 gün önce hatırlatma yapılacaktır")
           }, (err: any) => {
           console.error({ err });});


           }
           else{
            console.log(this.users1[i][0].status[0]);
            this.users1[i][0].status[0]="Tamamlandı";
           }
          }

           this.userData.updateJob(this.users1.key[i], this.users1[i][0].status[0]).subscribe();
           this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
           this.route.navigate(['otherjobs']));

         alert('İş Durumu Güncellendi')}

        updateJob(i:number) {this.toggle();
         this.recordTitle= this.users1[i][0].recordTitle;
         this.recordType= this.users1[i][0].recordType;
         this.recordDetail= this.users1[i][0].detail;
         this.recordAttorney= this.users1[i][0].attorneyName;
         this.recordTermination= this.users1[i][0].terminationDate;
         this.jobNumber=i;
         this.viewUpdateJob=true;
        }



       upload($event:any){
        this.path=$event.target.files[0];
        this.isFolderLoaded=($event.isTrusted);
      }
      onUpdate(){
        console.log("kayıt");
        this.userData.deleteJob(this.users1.key[this.jobNumber]);
        this.userData.deletionRecords([this.loggedUser,Date.now()],'İş Kayıt Verileri Güncellendi', `Güncellenen Dosya: ${this.users1[this.jobNumber][0].recordTitle} `).subscribe();
        this.onSubmit();
      }
    onSubmit() {


        var record=[];

        record.push({recordingUser:this.loggedUser, date:Date.now()});

            this.userData.addOtherJob(
                            this.recordTitle,
                            this.recordType,
                            this.recordDetail,

                            this.recordAttorney,
                            this.recordTermination,
                            record,
                            ["Devam Ediyor"]
                            ).
                            subscribe(arr=>{
                             // console.log(arr);
                              this.record="İş Kaydedildi";
                              alert("İş kaydedildi");
                              this.route.navigateByUrl('/bbf', {skipLocationChange: true}).then(()=>
           this.route.navigate(['otherjobs']));
                            },
                            err=>{
                            this.error=err.statusText;
                            console.log(this.error)});
                            const date = new Date(this.users1[this.jobNumber][0].terminationDate);
                            const reminderTime = (Math.floor (new Date(this.users1[this.jobNumber][0].terminationDate).getTime())/ 1000);
           const unixTimestamp = Math.floor(date.getTime() / 1000);
           const reminder= [unixTimestamp, reminderTime-172800,reminderTime-432000,]  // Termin tarihinden 2 gün ve 5 gün önce

           this.mailService.jobReminder(this.users1[this.jobNumber][0].terminationDate,this.users1[this.jobNumber][0].recordTitle, reminder).pipe(first())
           .subscribe((resp: any) => {
           console.log({ resp });

           alert("Termin tarihinden 2 gün ve 5 gün önce hatırlatma yapılacaktır")
           }, (err: any) => {
           console.error({ err });});
                            this.users=[];

  }
}
